if (!customElements.get('bs-tecidos-slider')) {
  class BsTecidosSlider extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector('.swiper-container');
      if (!container || !window.MinimogLibs || !window.MinimogLibs.Swiper) return;

      // No celular o proximo tecido aparece de canto (82px num 390, como os
      // cards da home e a galeria da PDP): com um card por tela, e cada card
      // bem alto, nao dava para perceber que havia outros ao lado (BES-227).
      // "auto" faz o Swiper ler a largura do card no bs-tecidos.css.
      this.slider = new window.MinimogLibs.Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: { slidesPerView: 2.3, spaceBetween: 16 },
          1024: { slidesPerView: 4, spaceBetween: 0 },
        },
      });
    }

    disconnectedCallback() {
      if (this.slider) this.slider.destroy();
    }
  }

  customElements.define('bs-tecidos-slider', BsTecidosSlider);
}
